import Tab from '@components/tabs'
import React, { Fragment, useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import PlayerProfile from './player-profile'
import MatchroomCreated from './matchroom-created'
import AdminMatchroom from './admin-matchroom'
import PlayerMatchroom from './player-matchroom'
import StoreOrders from './store-orders'
import Transactions from './transactions'
import Title from '@components/title'
import Column from '@components/column'
import { useSelector } from 'react-redux'
import { RootState } from '@store/index'
import { User } from '@apis/index'
import { Profile } from '@commons/cards/profile'
import useNavigateBack from '@hooks/useNavigateBack'

const IndividualUser = ({ userStateId }: { userStateId?: number }) => {
  const navigate = useNavigate()
  const { state: userId } = useLocation()
  const [activeTab, setActiveTab] = useState(0)
  const { data: user } = useSelector(
    (state: RootState) => state.inidividualUser,
  )

  const fetchUser = async () => {
    try {
      await User.find({ id: userId || userStateId, state: 'inidividualUser' })
    } catch (error) {}
  }
  useEffect(() => {
    fetchUser()
  }, [])
  const items = [
    {
      label: 'Player Profile',
      component: PlayerProfile,
      props: { user },
    },
    {
      label: 'Matchroom Created',
      component: MatchroomCreated,
      props: { user },
    },
    {
      label: 'Admin Matchroom',
      component: AdminMatchroom,
      props: { user },
    },
    {
      label: 'Player Matchroom',
      component: PlayerMatchroom,
      props: { user },
    },
    {
      label: 'Store Orders',
      component: StoreOrders,
      props: { user },
    },
    {
      label: 'Transactions',
      component: Transactions,
      props: { user },
    },
  ]
  const params = useParams()

  return (
    <Fragment>
      <Column>
        <Title
          textone="User Management >"
          texttwo="Details"
          textOneClick={() => navigate('/admin/user-management')}
        />
        <Profile user={user} />
        <Tab
          items={items}
          {...(userStateId
            ? { activeIndex: activeTab, onTabChange: setActiveTab }
            : {})}
        />
      </Column>
    </Fragment>
  )
}

export default IndividualUser
